module.exports = __webpack_public_path__ + "static/img/back2.37100ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back2.png
// module id = d9O0
// module chunks = 0